/**
 * Service API pour les commandes
 */

import { api, ApiResponse } from '../services/api';
import { Order, CreateOrderInput } from '../types/order';

interface OrdersResponse {
  orders: Order[];
  total: number;
}

interface OrderResponse {
  order: Order;
  message?: string;
}

export const orderApi = {
  /**
   * Recuperer toutes les commandes de l'utilisateur
   */
  async getMyOrders(params?: {
    status?: string;
    page?: number;
    pageSize?: number;
  }): Promise<ApiResponse<OrdersResponse>> {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());

    const query = queryParams.toString();
    return api.get<OrdersResponse>(`/api/orders/my${query ? `?${query}` : ''}`);
  },

  /**
   * Recuperer les details d'une commande
   */
  async getOrder(orderId: string): Promise<ApiResponse<OrderResponse>> {
    return api.get<OrderResponse>(`/api/orders/${orderId}`);
  },

  /**
   * Creer une nouvelle commande
   */
  async createOrder(data: CreateOrderInput): Promise<ApiResponse<OrderResponse>> {
    return api.post<OrderResponse>('/api/orders', data);
  },

  /**
   * Annuler une commande
   */
  async cancelOrder(orderId: string, reason?: string): Promise<ApiResponse<OrderResponse>> {
    return api.post<OrderResponse>(`/api/orders/${orderId}/cancel`, { reason });
  },
};
